<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddAttribute()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_attribute.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditAttribute()" v-if="permissionList.includes(permission.edit)">{{$t('setting_attribute.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteAttribute()" v-if="permissionList.includes(permission.delete)">{{$t('setting_attribute.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addAttribute" :title="$t('setting_attribute.table_add')" @ok="addAttribute" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addAttributeForm" @submit.prevent="addAttribute">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxAdd.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_category')}}</template>
                            <b-form-select name="category" v-model="ajaxAdd.category">
                                <option value="bonus">{{$t('setting_attribute.table_bonus')}}</option>
                                <option value="feature">{{$t('setting_attribute.table_feature')}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_filter')}}</template>
                            <b-form-select name="filter" v-model="ajaxAdd.filter">
                                <option value="package">{{$t('setting_attribute.table_package')}}</option>
                                <option value="badge">{{$t('setting_attribute.table_badge')}}</option>
                                <option value="rank">{{$t('setting_attribute.table_rank')}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxAdd.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxAdd.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_remark')}}</template>
                            <b-form-input name="remark" v-model="ajaxAdd.remark"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('setting_attribute.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_attribute.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxAdd.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editAttribute" :title="$t('setting_attribute.table_edit')" @ok="editAttribute" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editAttributeForm" @submit.prevent="editAttribute">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_category')}}</template>
                            <b-form-select name="category" v-model="ajaxEdit.category">
                                <option value="bonus">{{$t('setting_attribute.table_bonus')}}</option>
                                <option value="feature">{{$t('setting_attribute.table_feature')}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_filter')}}</template>
                            <b-form-select name="filter" v-model="ajaxEdit.filter">
                                <option value="package">{{$t('setting_attribute.table_package')}}</option>
                                <option value="badge">{{$t('setting_attribute.table_badge')}}</option>
                                <option value="rank">{{$t('setting_attribute.table_rank')}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxEdit.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxEdit.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_attribute.table_remark')}}</template>
                            <b-form-input name="remark" v-model="ajaxEdit.remark"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('setting_attribute.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('setting_attribute.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxEdit.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,setting_attributeAjaxTable,setting_attributeAdd,getSetting_AttributeEdit,setting_attributeEdit,setting_attributeDelete} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',category:'',filter:'',sort:'',status:''},
            ajaxAdd:{code:'',category:'bonus',filter:'package',sort:10,status:1,remark:'',name:{cn:'',en:''},languageList:[]},
            ajaxEdit:{languageList:[]},
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'7D5F45',
                edit:'2F0085',
                delete:'75B129'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting_attribute.table_id'),
                width: '170'
            },{
                prop: "code",
                label: this.$t('setting_attribute.table_code'),
                width: '338'
            },{
                prop: "category",
                label: this.$t('setting_attribute.table_category'),
                width: '338'
            },{
                prop: "filter",
                label: this.$t('setting_attribute.table_filter'),
                width: '338'
            },{
                prop: "sort",
                label: this.$t('setting_attribute.table_sort'),
                width: '169'
            },{
                prop: "status",
                label: this.$t('setting_attribute.table_status'),
                width: '169'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = setting_attributeAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.category,this.ajaxSearch.filter,this.ajaxSearch.sort,this.ajaxSearch.status);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddAttribute(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = languageList();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.ajaxAdd.languageList = value.data;
                        self.$bvModal.show('addAttribute')
                    }
                });
            }
        },addAttribute(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxAdd.category){
                    this.validate = false;
                    this.errors.push('setting_attribute.error_category_empty');
                }
                if(!this.ajaxAdd.code){
                    this.validate = false;
                    this.errors.push('setting_attribute.error_code_empty');
                }
                if(!this.ajaxAdd.name.cn){
                    this.validate = false;
                    this.errors.push('setting_attribute.error_name_empty');
                }
                if(!this.ajaxAdd.name.en){
                    this.validate = false;
                    this.errors.push('setting_attribute.error_name_empty');
                }
                if(this.validate){
                    var form = document.getElementById('addAttributeForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    var result = setting_attributeAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text,
                    });
                } 
            }        
        },getEditAttribute(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSetting_AttributeEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editAttribute');
                        self.ajaxEdit = value.data;
                        self.ajaxEdit.languageList = value.language;
                    }else{
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text,
                        });
                    }
                })
            }
        },editAttribute(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(!this.ajaxEdit.category){
                    this.validate = false;
                    this.errors.push('setting_attribute.error_category_empty');
                }
                if(!this.ajaxEdit.code){
                    this.validate = false;
                    this.errors.push('setting_attribute.error_code_empty');
                }
                if(!this.ajaxEdit.name.cn){
                    this.validate = false;
                    this.errors.push('setting_attribute.error_name_empty');
                }
                if(!this.ajaxEdit.name.en){
                    this.validate = false;
                    this.errors.push('setting_attribute.error_name_empty');
                }
                if(this.validate){
                    var form = document.getElementById('editAttributeForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = setting_attributeEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text,
                    });
                } 
            }
        },deleteAttribute(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = setting_attributeDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
